import {
  StyledBody,
  TopBottomMargin,
} from "components/apiDocs/BrowseAllPage/style";
import React from "react";

const IntroductionPage: React.FC = () => {
  const licenceTermsAndPolicyUrl =
    "https://www.elexon.co.uk/data/balancing-mechanism-reporting-agent/copyright-licence-bmrs-data/";
  return (
    <StyledBody className="guidance">
      <h1>API Documentation</h1>
      <p>
        Elexon Insights Solution API Documentation is a comprehensive self
        service area for developers and Elexon data users to discover our
        published API endpoints. You can access technical documentations,
        schemas and standard definitions such as Open API, WADL and codes.
      </p>
      <p>
        It&apos;s easy to get started, browse our range of outputs to find the
        ones most relevant to you and learn how to request the data.
      </p>
      <p>
        The APIs are based on BMRS data and we are continuously adding new
        datasets, if there is an API that you are looking for and cannot find
        please get in touch.
      </p>
      <TopBottomMargin>
        <p>
          For more information, please email&nbsp;
          <a href="mailto:insightssupport@elexon.co.uk" className="is-link">
            insightssupport@elexon.co.uk
          </a>
        </p>
      </TopBottomMargin>
      <h1>Terms and Conditions</h1>
      <p>
        The copyright and other intellectual property rights within the API
        Documentation are vested in Elexon or appear with the consent of the
        copyright owner.
      </p>
      <p>
        These materials are made available for you for the purposes of your
        participation in the electricity industry. If you have an interest in
        the electricity industry, you may view, download, copy, distribute,
        modify, transmit, publish, sell or create derivative works (in whatever
        format) from this document or in other cases use for personal academic
        or other non-commercial purposes; you must acknowledge the source and
        follow the attribution stated in the{" "}
        <a
          href={licenceTermsAndPolicyUrl}
          className="is-link"
          target="_blank"
          rel="noreferrer"
        >
          BMRS Data Licence Terms.
        </a>
      </p>
      <p>
        All copyright and other proprietary notices contained in this API
        Documentation must be retained on any copy you make. All other rights of
        the copyright owner not expressly dealt with above are reserved. No
        representation, warranty or guarantee is made that the information in
        this API Documentation is accurate or complete. While care is taken in
        the collection and provision of this information, Elexon Limited shall
        not be liable for any errors, omissions, misstatements or mistakes in
        any information or damages resulting from the use of this information or
        action taken in reliance on it. The use of the Insights Solution APIs is
        governed by the{" "}
        <a
          href={licenceTermsAndPolicyUrl}
          className="is-link"
          target="_blank"
          rel="noreferrer"
        >
          BMRS Data Licence Terms.
        </a>
      </p>
    </StyledBody>
  );
};
export default IntroductionPage;
